var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.onSubmit}},[_vm._v("保存")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }